import { UIProvider } from 'mymoria-ui';
import React, { FunctionComponent } from 'react';
import { defaultTheme } from 'styles/themes';

const CustomUIProvider: FunctionComponent = ({ children }) => {
  return <UIProvider theme={defaultTheme}>{children}</UIProvider>;
};

export default CustomUIProvider;
